module.exports = __webpack_public_path__ + "media/assets/images/flags/jp-404cc9d8f569bc131f28b0d48a310100.svg";